import { Alert, Empty, InputNumber, Table, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalItem, SelectVentasItem, fmtFechaDia } from "../../../../Components/Items";
import { cantidadTexto, dinero } from "../rmaComun";

// Elige renglones de una venta del cliente para agregarlos al RMA. El servidor regresa lo
// que queda por devolver de cada renglón (entregado − devuelto − apartado en otros RMAs).
class ElegirRenglonesVentaRMA extends Component {
  state = {
    cargando: false,
    ventaId: undefined,
    venta: null,
    renglones: [],
    seleccion: [],
    cantidades: {},
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({ ventaId: undefined, venta: null, renglones: [], seleccion: [], cantidades: {} });
    }
  }

  yaEnRMA(renglon) {
    return (this.props.renglonesActuales || []).some(
      (actual) => actual.ventaRenglonId && String(actual.ventaRenglonId) === String(renglon.ventaRenglonId)
    );
  }

  consultarRenglones(ventaId) {
    this.setState({ ventaId, cargando: true, venta: null, renglones: [], seleccion: [], cantidades: {} });
    if (!ventaId) return this.setState({ cargando: false });
    axios
      .post(
        "rma/renglonesVentaRMA",
        { empresaId: this.props.empresaId, ventaId, clienteId: this.props.clienteId, rmaId: this.props.rmaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) {
          message.error(res.data.message || "No se pudieron leer los renglones de la venta");
          this.setState({ cargando: false });
          return;
        }
        const cantidades = {};
        res.data.renglones.forEach((renglon) => {
          cantidades[renglon.ventaRenglonId] = renglon.pendiente;
        });
        this.setState({ cargando: false, venta: res.data.venta, renglones: res.data.renglones, cantidades });
      })
      .catch(() => {
        message.error("No se pudieron leer los renglones de la venta");
        this.setState({ cargando: false });
      });
  }

  agregar() {
    const elegidos = this.state.renglones
      .filter((renglon) => this.state.seleccion.includes(renglon.ventaRenglonId))
      .map((renglon) => ({
        ...renglon,
        cantidadSolicitada: Number(this.state.cantidades[renglon.ventaRenglonId]) || 0,
      }));
    if (elegidos.length === 0) return message.info("Selecciona al menos un renglón");
    const sinCantidad = elegidos.find((renglon) => renglon.cantidadSolicitada <= 0);
    if (sinCantidad) return message.warning(`Captura la cantidad de "${sinCantidad.descripcion}"`);
    this.props.onAgregar(elegidos);
  }

  render() {
    const { venta } = this.state;
    const moneda = venta?.monedaAbreviacion || "";

    const columnas = [
      { title: "Código", dataIndex: "codigo", key: "codigo", width: 80 },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        render: (value, renglon) => (
          <>
            <div>{value}</div>
            <div style={{ marginTop: 2 }}>
              {this.yaEnRMA(renglon) && <Tag color="blue">Ya está en el RMA</Tag>}
              {renglon.esKit && (
                <Tooltip title="La devolución de kits no regresa sus componentes al inventario: solo admite nota de crédito sin mercancía o reemplazo.">
                  <Tag color="purple">Kit</Tag>
                </Tooltip>
              )}
              {renglon.controlaLotes && <Tag>Lotes</Tag>}
              {renglon.precioCero && <Tag color="orange">Precio 0</Tag>}
            </div>
          </>
        ),
      },
      { title: "Vendido", dataIndex: "cantidadVendida", key: "cantidadVendida", width: 75, align: "center", render: cantidadTexto },
      {
        title: "Devuelto",
        dataIndex: "devuelto",
        key: "devuelto",
        width: 75,
        align: "center",
        render: (value, renglon) =>
          renglon.apartada > 0 ? (
            <Tooltip title={`Además hay ${cantidadTexto(renglon.apartada)} apartados en ${renglon.apartadoEn.join(", ")}`}>
              {cantidadTexto(value)} <Tag color="gold">+{cantidadTexto(renglon.apartada)}</Tag>
            </Tooltip>
          ) : (
            cantidadTexto(value)
          ),
      },
      { title: "Pendiente", dataIndex: "pendiente", key: "pendiente", width: 80, align: "center", render: cantidadTexto },
      {
        title: "A devolver",
        key: "cantidad",
        width: 110,
        render: (value, renglon) => (
          <InputNumber
            size="small"
            min={0}
            max={renglon.pendiente}
            value={this.state.cantidades[renglon.ventaRenglonId]}
            disabled={renglon.pendiente <= 0 || this.yaEnRMA(renglon)}
            onChange={(cantidad) =>
              this.setState((anterior) => ({
                cantidades: { ...anterior.cantidades, [renglon.ventaRenglonId]: cantidad },
              }))
            }
            style={{ width: "100%" }}
          />
        ),
      },
      {
        title: "Precio neto",
        dataIndex: "precioUnitarioNeto",
        key: "precioUnitarioNeto",
        width: 110,
        align: "right",
        render: (value) => `${dinero(value)} ${moneda}`.trim(),
      },
    ];

    return (
      <ModalItem
        title="Agregar renglones desde una venta"
        visible={this.props.visible}
        spinning={this.state.cargando}
        onCancel={this.props.onCerrar}
        onOk={this.agregar.bind(this)}
        okText="Agregar al RMA"
        footer
        width={window.innerWidth > 1000 ? "75%" : "95%"}
        paddingTop
      >
        <div style={{ marginBottom: 12 }}>
          <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 4 }}>Venta del cliente</div>
          {/* key por cliente: el select solo carga sus primeras ventas al montarse */}
          <SelectVentasItem
            key={this.props.clienteId || "sinCliente"}
            empresaId={this.props.empresaId}
            headersToken={this.props.headersToken}
            clienteId={this.props.clienteId}
            value={this.state.ventaId}
            onChange={(ventaId) => this.consultarRenglones(ventaId)}
            placeholder="Busca por serie y folio"
            width="100%"
          />
        </div>

        {venta && (
          <div style={{ marginBottom: 8, fontSize: 12 }}>
            <b>{venta.serieNumero}</b> · {fmtFechaDia(venta.fechaVenta)} · {venta.factura ? "Factura" : "Remisión"}
            {moneda ? ` · ${moneda}` : ""}
          </div>
        )}
        {venta?.facturaGlobal && (
          <Alert
            type="warning"
            showIcon
            style={{ marginBottom: 8 }}
            message="Esta remisión está incluida en una factura global: no se le podrá emitir nota de crédito desde el RMA, solo reemplazo, reparación o rechazo."
          />
        )}

        {this.state.renglones.length > 0 ? (
          <Table
            size="small"
            rowKey="ventaRenglonId"
            dataSource={this.state.renglones}
            columns={columnas}
            pagination={false}
            scroll={{ x: 760 }}
            rowSelection={{
              selectedRowKeys: this.state.seleccion,
              onChange: (seleccion) => this.setState({ seleccion }),
              getCheckboxProps: (renglon) => ({ disabled: renglon.pendiente <= 0 || this.yaEnRMA(renglon) }),
            }}
          />
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={this.state.ventaId ? "La venta no tiene renglones" : "Elige una venta del cliente"}
          />
        )}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ElegirRenglonesVentaRMA);
